import SubLayout from "../../components/layout/SubLayout";
import bannerImage from "../../Assets/campagin/addCampainBanner.png";
import addUserIcon from "../../Assets/campagin/add-user-icon.svg";
import { InfoCircleOutlined } from "@ant-design/icons";

import {
  Button,
  Checkbox,
  Form,
  Input,
  Image,
  Row,
  Col,
  Select,
  Popover,
  message,
  Tooltip,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import AddUserModal from "./AddUserModal/AddUserModal";
import { CloseOutlined } from "@ant-design/icons";
import API_MANAGER from "../../API";
// import LoaderGif from "../../../Assets/loader.gif";
import AlertState from "../../components/common/AlertState";
import rightArrow from "../../Assets/campagin/right_arrow.svg";
import { capitalizeWords } from "../../utils";
import MobileHeader from "../../components/layout/MobileHeader";

const AddCampign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const cloneCampaign = location?.state?.isClone ? location?.state?.campaign : null;
  const cloneAdverts = cloneCampaign?.adverts || [];
  //state for storing user after clicking edit campaign
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [industries, setIndustries] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedUsers, setSelectedUser] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [checkSelected, setCheckSelected] = useState([]);
  const [users, setUsers] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [searchUsers, setSearchUsers] = useState("");
  const [alertState, setAlertState] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [storedCampaignData, setStoredCampaignData] = useState();
  const [permissionsSum, setPermissionSum] = useState(0);
  const [selectedCloneAdverts, setSelectedCloneAdverts] = useState(
    cloneAdverts.map((advert) => advert?.id || advert?._id).filter(Boolean)
  );
  const [form] = Form.useForm();
  const [mainUserData, setMainUserData] = useState({
    id: localStorage.getItem("userID"),
    name: localStorage.getItem("name"),
  });
  //storing users which are preselected on clicking edit campaign

  const pickId = (value) => {
    if (!value) return value;
    if (typeof value === "object") return value.id || value._id;
    return value;
  };

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getCloneStartDate = () => formatLocalDate(new Date());

  const getCloneEndDate = () => {
    const end = new Date();
    end.setDate(end.getDate() + 20);
    return formatLocalDate(end);
  };

  const buildClonedAdvertPayload = (advert, newCampaignId) => ({
    campaignId: newCampaignId,
    industry: pickId(advert?.industry),
    minSalary: advert?.minSalary,
    maxSalary: advert?.maxSalary || advert?.minSalary,
    hours: Number(advert?.hours || 0),
    jobDescription: advert?.jobDescription,
    isActive: true,
    jobDuration: pickId(advert?.jobDuration),
    startDate: getCloneStartDate(),
    endDate: getCloneEndDate(),
    targetHeadcount: Number(advert?.targetHeadcount || 0),
    employmentType: pickId(advert?.employmentType),
    jobTitle: pickId(advert?.jobTitle),
    discipline: pickId(advert?.discipline),
    roster: pickId(advert?.roster),
    softRequirements: advert?.softRequirements || {},
    hardRequirements: advert?.hardRequirements || {},
    postalCode: advert?.postalCode,
    suburb: advert?.suburb,
    state: pickId(advert?.state),
  });

  const resolveCreatedCampaignId = (response) =>
    response?.data?.data?.campaign?.id ||
    response?.data?.data?.campaign?._id ||
    response?.data?.data?.id ||
    response?.data?.data?._id;

  const onFinish = async (values) => {
    const updatedCheckSelected = [
      ...checkSelected,
      localStorage.getItem("userID"),
    ];
    const campaignPayload = {
      name: values?.name,
      projectCode: values?.projectCode,
      postalCode: values?.postalCode,
      suburb: values?.suburb,
      state: pickId(values?.state),
      isActive: true,
      industry: pickId(values?.industry),
      users: updatedCheckSelected,
    };
    try {
      setLoading(true);
      let newCampaignId;
      if (cloneCampaign && selectedCloneAdverts.length > 0) {
        const [firstAdvertId, ...remainingAdvertIds] = selectedCloneAdverts;
        const firstAdvertResponse = await API_MANAGER.getAdvertDetail(
          firstAdvertId
        );
        const firstAdvert = firstAdvertResponse?.data?.data;
        const cloneResponse = await API_MANAGER.createCampaignAdvert({
          campaign: campaignPayload,
          advert: buildClonedAdvertPayload(
            firstAdvert,
            "000000000000000000000000"
          ),
        });
        newCampaignId = resolveCreatedCampaignId(cloneResponse);
        if (remainingAdvertIds.length > 0 && newCampaignId) {
          await Promise.all(
            remainingAdvertIds.map(async (advertId) => {
              const advertResponse = await API_MANAGER.getAdvertDetail(advertId);
              const advert = advertResponse?.data?.data;
              if (!advert) return;
              await API_MANAGER.createAdvert(
                buildClonedAdvertPayload(advert, newCampaignId)
              );
            })
          );
        }
      } else if (cloneCampaign) {
        const response = await API_MANAGER.createCampaignRoot(campaignPayload);
        newCampaignId = resolveCreatedCampaignId(response);
      } else {
        let response;
        if (localStorage.getItem("user") === "Root") {
          response = await API_MANAGER.createCampaignRoot(campaignPayload);
        } else {
          response = await API_MANAGER.createCampaign(campaignPayload);
        }
        newCampaignId = resolveCreatedCampaignId(response);
      }
      form.resetFields();
      setLoading(false);
      message.success(
        cloneCampaign
          ? "Campaign successfully cloned."
          : "Campaign successfully created."
      );
      localStorage.removeItem("campaignData");
      navigate(`/campaign-detail/${newCampaignId}`);
    } catch (error) {
      setLoading(false);
      message?.error("Something went wrong. Please try again.");
    }
  };
  const onFinishFailed = (errorInfo) => {};
  const handleGoBack = () => {
    navigate(-1);
  };
  const options = [];
  for (let i = 10; i < 360; i++) {
    options.push({
      value: i.toString(36) + i,
      label: i.toString(36) + i,
    });
  }

  const handleAddUserModal = () => {
    setUserModalOpen(true);
  };
  const handleOk = (users) => {
    setUserModalOpen(false);
    setSelectedUser(users);
    const selectedFieldValues = users?.map((user) => user.id);
    form.setFieldsValue({ users: selectedFieldValues });
  };
  const getIndustries = async () => {
    try {
      const response = await API_MANAGER.getTags("INDUSTRY&sort=name");
      setIndustries(response?.data?.data?.tags);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };
  const getStates = async () => {
    try {
      const response = await API_MANAGER.getTagsBySearch({
        type: "STATE",
        limit: 20000,
        sort: "name",
      });
      setStates(response?.data?.data?.tags);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };
  const getUsersList = async () => {
    const param = {
      search: searchUsers ? searchUsers : "",
      sort: "-createdAt",
    };
    try {
      const response = await API_MANAGER.getUsersList(param);
      const users = response?.data?.data?.filter(
        (e) => e?._id !== mainUserData?.id
      );
      setUsersList(users);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };
  useEffect(() => {
    getIndustries();
    getStates();
  }, []);
  useEffect(() => {
    getUsersList();
  }, [searchUsers]);

  const initialState = {
    name: storedCampaignData?.name || "",
    postalCode: storedCampaignData?.postalCode || "",
    projectCode: storedCampaignData?.projectCode || "",
    state: storedCampaignData?.state || "",
    industry: storedCampaignData?.industry || "",
    suburb: storedCampaignData?.suburb || "",
    state: storedCampaignData?.state || "",
  };
  const handleInputChange = (text, value) => {
    initialState[value] = text;

    localStorage.setItem("campaignData", JSON.stringify(initialState));
  };

  //user save to LS
  useEffect(() => {
    const usersSelected = JSON.parse(localStorage.getItem("usersData"));
    if (usersSelected === null)
      localStorage.setItem("usersData", JSON.stringify(selectedUsers));
    else {
      const updatedUsers = [...usersSelected];
      setSelectedUser(updatedUsers);
    }
  }, []);
  useEffect(() => {
    const campaignData = JSON.parse(localStorage.getItem("campaignData"));
    setStoredCampaignData(campaignData);
    form.setFieldsValue({ name: campaignData?.name });
    form.setFieldsValue({
      targetHeadCount: campaignData?.targetHeadCount,
    });
    form.setFieldsValue({ projectCode: campaignData?.projectCode });
    form.setFieldsValue({ suburb: campaignData?.suburb });
    form.setFieldsValue({ postalCode: campaignData?.postalCode });
    form.setFieldsValue({ state: campaignData?.state });
    form.setFieldsValue({ industry: campaignData?.industry });

    if (cloneCampaign) {
      const cloneUsers = (cloneCampaign?.users || []).filter(
        (user) => (user?.id || user?._id) !== localStorage.getItem("userID")
      );
      form.setFieldsValue({
        name: cloneCampaign?.name ? `${cloneCampaign.name} copy` : "",
        projectCode: cloneCampaign?.projectCode || "",
        suburb: cloneCampaign?.suburb || "",
        postalCode: cloneCampaign?.postalCode || "",
        industry: cloneCampaign?.industry?.id || cloneCampaign?.industry?._id,
        state: cloneCampaign?.state?.id || cloneCampaign?.state?._id,
      });
      setSelectedUser(cloneUsers);
      setCheckSelected(cloneUsers.map((user) => user?.id || user?._id));
    }
  }, []);

  const handleCrossIcon = async (event, item) => {
    event.stopPropagation();
    const itemId = item?._id || item?.id;
    
    const updateUserList = selectedUsers.filter(
      (itemSelected) => (itemSelected._id || itemSelected.id) !== itemId
      );
      const updatedCheckSelected = checkSelected.filter(
      (itemSelected) => itemSelected !== itemId
    );
    const updatedUsers = users.filter(
      (itemSelected) => (itemSelected._id || itemSelected.id) !== itemId
      );
      
    setUsers(updatedUsers);
      setCheckSelected(updatedCheckSelected);
      setSelectedUser(updateUserList);
    
      const selectedFieldValues = updateUserList?.map((user) => user.id || user._id);
      form.setFieldsValue({ users: selectedFieldValues });
      
      localStorage.setItem("usersData", JSON.stringify(updateUserList));
      
      const updatedCheckSelectedWithMain = [
        ...updatedCheckSelected,
        localStorage.getItem("userID"),
      ];
      const currentFormValues = form.getFieldsValue();
      const updatePayload = {
        ...currentFormValues,
        users: updatedCheckSelectedWithMain,
        isActive: true,
      };
      
      const draftCampaignId = localStorage.getItem("draftCampaignId");
      if (draftCampaignId) {
        try {
          setLoading(true);
          await API_MANAGER.updateCampaign_management(
            updatePayload,
            draftCampaignId
          );
          setLoading(false);
          message.success("User successfully removed.");
        } catch (error) {
          setLoading(false);
          const errMsg = error?.response?.data?.message;
          message.error(typeof errMsg === 'string' ? errMsg : (errMsg?.message || "Failed to update campaign. Please try again."));
        }
      } else {
        const campaignData = JSON.parse(localStorage.getItem("campaignData")) || {};
        localStorage.setItem("campaignData", JSON.stringify({
          ...campaignData,
          users: updatedCheckSelectedWithMain
        }));
    }
  };

  const handleRemoveMainUser = (event) => {
    event.stopPropagation();
    message.error("Main user cannot be removed.");
  };
  useEffect(() => {
    const permissions = localStorage.getItem("permissions");
    let sum = 0;
    for (let i = 0; i < permissions?.length; i++) {
      sum += permissions[i];
    }
    setPermissionSum(sum);
  });

  return (
    <>
      <AlertState
        state={alertState}
        message={alertMessage}
        alertOpen={alertOpen}
        setAlertOpen={setAlertOpen}
      />
      <SubLayout page={cloneCampaign ? "Clone Campaign" : "Create Campaign"} whiteBg showBack>
        <AddUserModal
          isModalOpen={userModalOpen}
          setUserModalOpen={setUserModalOpen}
          data={usersList}
          handleOk={handleOk}
          checkSelected={checkSelected}
          setCheckSelected={setCheckSelected}
          users={users}
          setUsers={setUsers}
          searchUsers={searchUsers}
          setSearchUsers={setSearchUsers}
        />

        <div className="add_campaign_main_container">
          <Row>
            <Col xs={0} md={24} className="banner_img_col">
              <Image preview={false} src={bannerImage} />
            </Col>
          </Row>
          {/* for small screen only */}
          <Row>
            <Col xs={24} md={0}>
              <MobileHeader title={cloneCampaign ? "Clone Campaign" : "Add Campaign"} />
            </Col>
          </Row>
          {/* Form Start */}
          <div className="form_main_div">
            <Form
              form={form}
              name="basic"
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              layout="vertical"
              requiredMark={false}
            >
              <div className="form_div">
                <Row justify={"space-between"}>
                  <Col xs={24} md={11}>
                    <Form.Item
                      label="Campaign Name/Project Name*"
                      name="name"
                      rules={[
                        {
                          required: true,
                          message: "Please input campaign name/project name!",
                        },
                      ]}
                    >
                      <Input
                        className="form_input_box"
                        autoFocus
                        placeholder="Add campaign name/project name"
                        onChange={(e) =>
                          handleInputChange(e.target.value, "name")
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={11}>
                    <Form.Item
                      label={
                        <div>
                          Target Headcount
                          <Tooltip title="The campaign's target headcount is automatically calculated from each advert's target headcount.">
                            <InfoCircleOutlined
                              className="cursor_pointer"
                              style={{ marginLeft: "5px" }}
                            />
                          </Tooltip>
                        </div>
                      }
                      name="targetHeadCount"
                    >
                      <Input
                        className="form_input_box"
                        placeholder="Target headcount"
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify={"space-between"}>
                  <Col xs={24} md={11}>
                    <Form.Item
                      label="Project Code"
                      name="projectCode"
                      rules={[
                        {
                          required: false,
                          message: "Please input project code!",
                        },
                      ]}
                    >
                      <Input
                        className="form_input_box"
                        placeholder="Add project code"
                        type="text"
                        onChange={(e) =>
                          handleInputChange(e.target.value, "projectCode")
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={11}>
                    <Form.Item
                      label="Industry*"
                      name="industry"
                      rules={[
                        {
                          required: true,
                          message: "Please input industry!",
                        },
                      ]}
                    >
                      <Select
                        className="select_input_form"
                        placeholder="Add industry"
                        showSearch
                        optionFilterProp="children"
                        onChange={(e) => handleInputChange(e, "industry")}
                        filterOption={(input, option) =>
                          option?.label
                            ?.toLowerCase()
                            .includes(input?.toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          optionA?.label
                            ?.toLowerCase()
                            .localeCompare(optionB?.label?.toLowerCase())
                        }
                      >
                        {industries?.map((item, index) => (
                          <Select.Option
                            value={item?.id}
                            key={index}
                            label={item?.name}
                          >
                            {item?.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify={"space-between"}>
                  <Col xs={24} md={11}>
                    <Form.Item
                      label="Suburb*"
                      name="suburb"
                      rules={[
                        {
                          required: true,
                          message: "Please input suburb!",
                        },
                      ]}
                    >
                      <Input
                        className="form_input_box"
                        placeholder="Add suburb"
                        onChange={(e) =>
                          handleInputChange(e.target.value, "suburb")
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={11}>
                    <Form.Item
                      label="State*"
                      name="state"
                      rules={[
                        {
                          required: true,
                          message: "Please input state!",
                        },
                      ]}
                    >
                      <Select
                        className="select_input_form"
                        showSearch
                        optionFilterProp="children"
                        placeholder="Add state"
                        onChange={(e) => handleInputChange(e, "state")}
                      >
                        {states?.map((item, index) => (
                          <Select.Option
                            value={item?.id}
                            key={index}
                            label={item?.name}
                          >
                            {item?.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify={"space-between"}>
                  <Col xs={24} md={11}>
                    <Form.Item
                      label="Postal Code*"
                      name="postalCode"
                      rules={[
                        {
                          required: true,
                          message: "Please input postal code!",
                        },
                      ]}
                    >
                      <Input
                        className="form_input_box"
                        placeholder="Add postal code"
                        onChange={(e) =>
                          handleInputChange(e.target.value, "postalCode")
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={11}>
                    <label>
                      <Row justify={"space-between"}>
                        <Col span={12} style={{ marginBottom: "8px" }}>
                          Users*
                        </Col>
                      </Row>
                    </label>
                    <Form.Item
                      name="users"
                      rules={[
                        {
                          required: false,
                          message: "Please add users!",
                        },
                      ]}
                    >
                      <div
                        className="form_input_div"
                        placeholder="add user"
                      >
                        <div 
                          className="multi_select_item_block"
                          onClick={handleAddUserModal}
                        >
                          <span>
                            {mainUserData?.name}
                          </span>
                          <CloseOutlined
                            style={{ 
                              marginLeft: "8px", 
                              cursor: "pointer",
                              fontSize: "12px"
                            }}
                            onClick={(e) => handleRemoveMainUser(e)}
                          />
                        </div>

                        {selectedUsers.slice(0, 2).map((item, index) => {
                          return (
                            <div 
                              key={index}
                              className="multi_select_item_block"
                              onClick={handleAddUserModal}
                            >
                              <span>{`${item?.firstName} ${item?.lastName}`}</span>
                              <CloseOutlined
                                style={{ 
                                  marginLeft: "8px", 
                                  cursor: "pointer",
                                  fontSize: "12px"
                                }}
                                onClick={(e) => handleCrossIcon(e, item)}
                              />
                            </div>
                          );
                        })}
                        {selectedUsers.length > 2 && (
                          <Popover
                            className="aaa"
                            placement="topLeft"
                            trigger="click"
                            content={
                              <div className="popover_contentDiv">
                                <Row>
                                  {selectedUsers.slice(2).map((item, index) => (
                                    <Col key={index} span={24} className="popover_item_col">
                                      <span className="greendot"></span>
                                      <span>
                                        {item?.firstName}&nbsp;{item?.lastName}
                                      </span>
                                    </Col>
                                  ))}
                                </Row>
                              </div>
                            }
                          >
                            <div 
                              className="count_div"
                              style={{ cursor: "pointer" }}
                            >
                              <span>+{selectedUsers.length - 2}</span>
                            </div>
                          </Popover>
                        )}
                        <div 
                          style={{ 
                            flex: 1, 
                            minHeight: "32px",
                            cursor: "pointer"
                          }}
                          onClick={handleAddUserModal}
                        />
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
                {cloneAdverts.length > 0 && (
                  <Row>
                    <Col span={24}>
                      <div className="clone-adverts-card">
                        <div className="clone-adverts-header">
                          <div>
                            <p className="clone-adverts-title">Adverts to clone</p>
                            <p className="clone-adverts-subtitle">
                              Choose which job adverts to copy into the new campaign
                            </p>
                          </div>
                          <span className="clone-adverts-count">
                            {selectedCloneAdverts.length}/{cloneAdverts.length} selected
                          </span>
                        </div>
                        <div className="clone-adverts-toolbar">
                          <Checkbox
                            checked={
                              selectedCloneAdverts.length > 0 &&
                              selectedCloneAdverts.length === cloneAdverts.length
                            }
                            indeterminate={
                              selectedCloneAdverts.length > 0 &&
                              selectedCloneAdverts.length < cloneAdverts.length
                            }
                            onChange={(e) => {
                              setSelectedCloneAdverts(
                                e.target.checked
                                  ? cloneAdverts
                                      .map((advert) => advert?.id || advert?._id)
                                      .filter(Boolean)
                                  : []
                              );
                            }}
                          >
                            Select all
                          </Checkbox>
                        </div>
                        <div className="clone-advert-list">
                          {cloneAdverts.map((advert) => {
                            const advertId = advert?.id || advert?._id;
                            const isChecked = selectedCloneAdverts.includes(advertId);
                            return (
                              <label
                                key={advertId}
                                className={`clone-advert-item ${isChecked ? "selected" : ""}`}
                              >
                                <Checkbox
                                  checked={isChecked}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedCloneAdverts([
                                        ...selectedCloneAdverts,
                                        advertId,
                                      ]);
                                    } else {
                                      setSelectedCloneAdverts(
                                        selectedCloneAdverts.filter(
                                          (id) => id !== advertId
                                        )
                                      );
                                    }
                                  }}
                                />
                                <span className="clone-advert-item-body">
                                  <span className="clone-advert-name">
                                    {advert?.jobTitle?.name || "Untitled advert"}
                                  </span>
                                  {advert?.targetHeadcount ? (
                                    <span className="clone-advert-meta">
                                      Target headcount {advert.targetHeadcount}
                                    </span>
                                  ) : null}
                                </span>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
              <Row className="submit_button_row ">
                <Col span={24}>
                  <Row
                    justify={"end"}
                    gutter={24}
                    className="specialBtn-parent"
                  >
                    <Col>
                      <Button
                        className="button_no_border specialBtn_one"
                        onClick={() => {
                          localStorage.removeItem("campaignData");
                          navigate("/campaign-management");
                        }}
                      >
                        Cancel
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        className="button_1 specialBtn_two"
                        htmlType="submit"
                        loading={loading}
                      >
                        {cloneCampaign ? "Clone Campaign" : "Create Campaign"}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </SubLayout>
    </>
  );
};
export default AddCampign;
